import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { FastField, FieldProps } from 'formik';
import React from 'react';
import { UnitOfPriceOptions as unitOfPrices } from '../../../constants/unitOfPrice';

interface UnitOfPriceFastFieldProps {
  name: string;
  label: string;
  [x: string]: any;
}

const UnitOfPriceFastField: React.FC<UnitOfPriceFastFieldProps> = (props) => {
  const { name, label, disabled = false, ...other } = props;
  return (
    <FastField name={name} key={`${name}-${disabled ? 'disabled' : 'enabled'}`}>
      {({
        field, // { name, value, onChange, onBlur }
        form, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
        meta,
      }: FieldProps<any>) => {
        return (
          <FormControl fullWidth>
            <InputLabel id={name}>{label}</InputLabel>
            <Select
              labelId={name}
              disabled={disabled}
              onChange={(
                event: React.ChangeEvent<{
                  value: unknown;
                }>,
              ) => {
                form.setFieldValue(name, event.target.value as string);
              }}
              {...field}
              {...other}
            >
              {unitOfPrices.map((unitOfPrice) => (
                <MenuItem key={unitOfPrice.value} value={unitOfPrice.value}>
                  {unitOfPrice.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        );
      }}
    </FastField>
  );
};

export default UnitOfPriceFastField;
